export default {
    TASK_RESULT_LIMIT: "Количество результатов"
};
